module.exports = __webpack_public_path__ + "img/infrastructure.94f61fe1.svg";